import type { BlogPageMetadata } from '$lib/types/BlogPageMetadata';

export type BlogPageSlug =
	| '5-common-investing-mistakes'
	| 'crypto-trading-101'
	| 'from-novice-to-pro-investment-foundation'
	| 'fundamental-v-technical-analysis-for-blue-chip-stocks'
	| 'fundamental-v-technical-analysis-for-meme-stocks'
	| 'impact-of-breaking-news-on-stock-prices'
	| 'real-time-market-data-importance'
	| 'social-investing'
	| 'top-10-meme-stock-indicators'
	| 'v2';

export const BLOG_PAGES_DIRECTORY: Record<BlogPageSlug, BlogPageMetadata> = {
	'5-common-investing-mistakes': {
		datePublished: 'August 29, 2024',
		description:
			"Discover the 5 most common mistakes novice investors make and learn how Tickrr's advanced tools can help you avoid them. From failing to research to emotional decision-making, this guide shows you how to invest smarter.",
		headerImage: '/images/blog/5-common-investing-mistakes/header.avif',
		title: '5 Common Mistakes Novice Investors Make and How Tickrr Can Help Avoid Them'
	},
	'crypto-trading-101': {
		datePublished: 'August 28, 2024',
		description:
			"Dive into the world of cryptocurrency trading with this comprehensive beginner's guide. Learn the basics of crypto, essential trading strategies, and how to use Tickrr's powerful tools for successful trading.",
		headerImage: '/images/blog/crypto-trading-101/header.webp',
		title: "Cryptocurrency Trading 101: A Beginner's Guide with Tickrr"
	},
	'from-novice-to-pro-investment-foundation': {
		datePublished: 'September 5, 2024',
		description:
			"Embark on your journey from novice to professional investor with Tickrr's comprehensive toolkit. Learn essential strategies, risk management techniques, and how to leverage advanced features for long-term success in the markets.",
		headerImage: '/images/blog/from-novice-to-pro-investment-foundation/header.avif',
		title: "From Novice to Pro: Building a Solid Investment Foundation with Tickrr's Tools"
	},
	'fundamental-v-technical-analysis-for-blue-chip-stocks': {
		datePublished: 'August 27, 2024',
		description:
			'Explore the strengths and weaknesses of fundamental vs. technical analysis for blue chip stocks. Learn how to combine both approaches for a comprehensive investment strategy.',
		headerImage: '/images/blog/fundamental-v-technical-analysis-for-blue-chip-stocks/header.avif',
		title: 'Fundamental vs. Technical Analysis: Which Approach Works Best for Blue Chip Stocks?'
	},
	'fundamental-v-technical-analysis-for-meme-stocks': {
		datePublished: 'August 29, 2024',
		description:
			"Explore the pros and cons of fundamental vs. technical analysis for meme stocks. Learn how to combine both approaches using Tickrr's advanced tools for smarter trading decisions.",
		headerImage: '/images/blog/fundamental-v-technical-analysis-for-meme-stocks/header.avif',
		title: 'Fundamental vs. Technical Analysis: Which Should You Use for Meme Stocks?'
	},
	'impact-of-breaking-news-on-stock-prices': {
		datePublished: 'September 1, 2024',
		description:
			"Explore how breaking news affects stock prices and learn strategies to capitalize on these movements. Discover how Tickrr's real-time news feeds and advanced analytics help you stay ahead of the market.",
		headerImage: '/images/blog/impact-of-breaking-news-on-stock-prices/header.avif',
		title: 'The Impact of Breaking News on Stock Prices: How to Stay Ahead with Tickrr'
	},
	'real-time-market-data-importance': {
		datePublished: 'August 30, 2024',
		description:
			"Discover why real-time market data is essential for modern investors. Learn how Tickrr's cutting-edge tools provide instant insights, helping you make informed decisions and stay ahead in today's fast-paced markets.",
		headerImage: '/images/blog/real-time-market-data-importance/header.avif',
		title: "Real-Time Market Data: Why It's Crucial for Modern Investors"
	},
	'social-investing': {
		datePublished: 'August 29, 2024',
		description:
			"Discover how social investing is revolutionizing trading and learn to leverage Tickrr's community features for smarter investment decisions. Explore social feeds, leaderboards, copy trading, and more.",
		headerImage: '/images/blog/social-investing/header.avif',
		title: "The Rise of Social Investing: How Tickrr's Community Features Give You an Edge"
	},
	'top-10-meme-stock-indicators': {
		datePublished: 'August 27, 2024',
		description:
			"Master the top 10 technical indicators essential for meme stock trading success. Learn how to use RSI, MACD, Bollinger Bands, and more with Tickrr's advanced charting tools.",
		headerImage: '/images/blog/top-10-meme-stock-indicators/header.jpg',
		title: 'Top 10 Technical Indicators Every Meme Stock Trader Should Know'
	},
	v2: {
		datePublished: 'August 1, 2024',
		description: 'Read about the launch of Tickrr V2, a major update to the platform.',
		headerImage: '/images/blog/launch/header.webp',
		title: 'Tickrr V2 Launch'
	}
};
